function displayContent(content: string | number | null | undefined): string | number {
  if (typeof content === "string" && content?.length === 0) return "—";
  return content || "—";
}

function keyToHuman(string: string): string {
  return string.replace(/-/g, " ");
}

function humanToKey(string: string): string {
  return string.toLowerCase().replace(/ /g, "-");
}

function capitaliseFirstLetter(string: string): string {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function snakeToHuman(string: string): string {
  return string.replace(/_/g, " ");
}

function snakeToKey(string: string): string {
  return string.replace(/_/g, "-");
}

function capitaliseEveryFirstLetter(string: string): string {
  return string
    .split(" ")
    .map(word => capitaliseFirstLetter(word))
    .join(" ");
}

function formatCurrency(
  amount: number,
  currency: string = "ZAR",
  locale: string = "en-ZA"
): string {
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
  }).format(amount);
}

export {
  displayContent,
  keyToHuman,
  humanToKey,
  capitaliseFirstLetter,
  capitaliseEveryFirstLetter,
  snakeToHuman,
  snakeToKey,
  formatCurrency,
};
